import { useRoutes } from "react-router-dom/dist";
import Routes from "./Routes";
import { Toaster } from "react-hot-toast";
import GoogleAnalytics from "./components/shared/ui/GoogleAnalytics";
import { HelmetProvider } from "react-helmet-async";
import Seo from "./components/shared/ui/Seo";
import AppDownloadPrompt from "./components/shared/ui/AppDownloadPrompt";
import { LikeProvider } from "./store/LikeContext";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_WEB_CLIENT_ID } from "./utils/constants";

function App() {
  const helmetContext = {};
  return (
    <>
      <GoogleOAuthProvider clientId={GOOGLE_WEB_CLIENT_ID}>
        <HelmetProvider context={helmetContext}>
          <LikeProvider>
            <GoogleAnalytics />
            <Seo />
            {useRoutes(Routes)}
            <Toaster />
            <AppDownloadPrompt />
          </LikeProvider>
        </HelmetProvider>
      </GoogleOAuthProvider>
    </>
  );

}

export default App;
